import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TaskProgressStatus } from '@app/shared/interfaces';
import { IconComponent, LoadingSpinnerComponent } from '@ui';
import { TaskProgressService } from '../task-progress.service';

@Component({
  selector: 'sbnb-task-progress-tracker',
  standalone: true,
  imports: [CommonModule, IconComponent, LoadingSpinnerComponent],
  templateUrl: './task-progress-tracker.component.html',
  styles: ``,
  host: {
    class: 'block h-full',
  },
})
export class TaskProgressTrackerComponent {
  readonly #taskProgressService = inject(TaskProgressService);

  readonly progressStatus = input.required<TaskProgressStatus>();

  readonly progressSteps = computed(() => this.#taskProgressService.getProgressSteps(this.progressStatus()));
}
